// PAYMENT PROGRESS
import WDHPaymentProgress from "../../../../wdh-feature/wdh-payment-progress/src/js/wdh-payment-progress";
var paymentProgress = new WDHPaymentProgress();
paymentProgress.run();